import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFullProfile } from '../redux/actions/profile-actions';
import { fetchPublisherInfo } from '../redux/actions/publisher-actions';
import LoadFullProfile from '../components/load-full-profile';

const mapStateToProps = ({
  auth: { uid },
  profile: { isLoading: profileIsLoading, profileLoaded },
  publisher: { remoteStoreState: publisherRemoteStoreState },
}) => ({
  uid,
  profileIsLoading,
  publisherRemoteStoreState,
  profileLoaded,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchFullProfile, fetchPublisherInfo }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoadFullProfile);
